import olTileWMS from 'ol/source/TileWMS'
import olWMTS from 'ol/source/WMTS'
import olXYZ from 'ol/source/XYZ'

/**
 * Wrapper classes for TileSources that dispatch events for loading all requested tiles
 */
class TileWMS extends olTileWMS {
  constructor(opts) {
    super(opts)
    _setEvents(this)
  }
}

class WMTS extends olWMTS {
  constructor(opts) {
    super(opts)
    _setEvents(this)
  }
}

class XYZ extends olXYZ {
  constructor(opts) {
    super(opts)
    _setEvents(this)
  }
}

function _setEvents(ctx) {
  ctx._requestedTiles = 0
  ctx._completedTiles = 0
  ctx.on('tileloadend', _handleLoadStartEnd.bind(ctx))
  ctx.on('tileloaderror', _handleLoadStartEnd.bind(ctx))
  ctx.on('tileloadstart', _handleLoadStart.bind(ctx))
}

function _handleLoadStart(e) {
  this._requestedTiles++
  if (this._requestedTiles === 1) {
    this.dispatchEvent({
      type: 'load-state',
      layer: this.id,
      state: 'loading',
    })
  }
}

function _handleLoadStartEnd(e) {
  this._completedTiles++
  if (this._requestedTiles === this._completedTiles) {
    this._requestedTiles = 0
    this._completedTiles = 0
    this.dispatchEvent({
      type: 'load-state',
      layer: this.id,
      state: 'loaded',
    })
  }
}

export { WMTS, TileWMS, XYZ }
